export default __webpack_public_path__ + "static/media/london.cb468505.jpg";